import React, { useEffect, useState } from "react";

import styled from "styled-components";
import { withRouter } from "react-router-dom";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ModifiedMetaTags from '../../../components/ModifiedMetaTags/index';

const IDGenerator = () => {
  const defaultVal = '- - - - - - - - - -';
  const [key, setKey] = useState(defaultVal);

  useEffect(() => {
    return () => {
      setKey(defaultVal);
    };
  }, []);

  const generateRandomId = () => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let id = "";

    for (let i = 0; i < 20; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      id += characters.charAt(randomIndex);
    }

    setKey(id);
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <ModifiedMetaTags title="ID Generator | Mobihunter" />

        <Container fluid>
          <Breadcrumbs
            title="Dashboard"
            breadcrumbItem="ID Generator"
            link="/id-generator"
          />

          <div
            className="checkout-tabs"
            style={{ position: "relative", height: "75vh" }}
          >
            <Row
              className="d-flex justify-content-center"
              style={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
              }}
            >
              <Col md="4" lg="4" xl="4">
                <Card>
                  <CardBody>
                    <Row className="d-flex text-center">
                      <span style={{ fontSize: 15 }}>Generated ID</span>
                    </Row>
                    <Row className="d-flex text-center p-2">
                      <StyledKey>{key}</StyledKey>
                    </Row>
                    <Row className="d-flex justify-content-center">
                      <Button
                        type="button"
                        color="primary"
                        className="btn-rounded my-2 me-2"
                        style={{ maxWidth: 100 }}
                        onClick={generateRandomId}
                      >
                        Generate
                      </Button>
                      <Button
                        type="button"
                        color="success"
                        className="btn-rounded my-2"
                        style={{ maxWidth: 100 }}
                        disabled={key == defaultVal}
                        onClick={() => {
                          navigator.clipboard.writeText(key);
                        }}
                      >
                        Copy
                      </Button>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

const StyledKey = styled.div`
  font-size: 23px;
  border: 1px solid #556ee6;
  border-radius: 15px;
  margin: 25px 0;
  background: white;
`;

IDGenerator.propTypes = {
  permissions: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {})(withRouter(IDGenerator));
